import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home'; 
import Klienci from './components/Klienci'; 
import Zlecenia from './components/Zlecenia'; 
import Pracownicy from './components/Pracownicy'; 
import Logowanie from './components/uzytkownicy/Logowanie';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import SzczegolyKlienta from './components/klienci/SzczegolyKlienta';
import Uzytkownik from './components/uzytkownicy/uzytkownik';
import Przeglady from './components/Przeglady';
import ImportEksport from './components/ImportEksport';
import ListaUrzadzen from './components/ListaUrzadzen';
import Uzytkownicy from './components/Uzytkownicy';
import TowaryUslugi from './components/TowaryUslugi';
import UstawieniaMagazynu from './components/UstawieniaMagazynu';
import Ustawienia from './components/Ustawienia';
import Guard from './components/auth/Guard';
import { AuthProvider, useAuth } from './auth/AuthContext';

function AppRoutes() {
  const { isAuthenticated, user, loading, login, logout } = useAuth();
  const [navVisibility, setNavVisibility] = useState('nav-hidden');

  const changeMenuMobileVisibility = () => {
    setNavVisibility((prev) => (prev === 'nav-hidden' ? 'nav-shown' : 'nav-hidden'));
  };

  if (loading) {
    return <div>Ładowanie...</div>;
  }

  return (
    <Routes>
      <Route path="/logowanie" element={<Logowanie onZaloguj={login} />} />
      <Route
        path="/*"
        element={
          isAuthenticated ? (
            <>
              <Header uzytkownik={user} onWyloguj={logout} onChangeMenuMobileVisibility={changeMenuMobileVisibility} />
              <div style={{ display: 'flex' }}>
                <Sidebar uzytkownik={user} navClass={navVisibility} visibilityChange={changeMenuMobileVisibility} />
                <div style={{ flex: 1, padding: '20px' }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/klienci" element={<Guard permission="page_clients_view" fallback={<Navigate to="/" />}><Klienci /></Guard>} />
                    <Route path="/zlecenia" element={<Guard permission="page_orders_view" fallback={<Navigate to="/" />}><Zlecenia uzytkownik={user} /></Guard>} />
                    <Route path="/pracownicy" element={<Guard permission="page_employees_view" fallback={<Navigate to="/" />}><Pracownicy /></Guard>} />
                    <Route path="/klienci/:klientId" element={<Guard permission="page_clients_view" fallback={<Navigate to="/" />}><SzczegolyKlienta uzytkownik={user} /></Guard>} />
                    <Route path="/uzytkownik" element={<Uzytkownik />} />
                    <Route path="/przeglady" element={<Guard permission="page_reviews_view" fallback={<Navigate to="/" />}><Przeglady uzytkownik={user} /></Guard>} />
                    <Route path="/importeksport" element={<Guard permission="page_import_export_view" fallback={<Navigate to="/" />}><ImportEksport /></Guard>} />
                    <Route path="/listaurzadzen" element={<Guard permission="page_devices_view" fallback={<Navigate to="/" />}><ListaUrzadzen /></Guard>} />
                    <Route path="/uzytkownicy/dodaj" element={<Guard permission="page_users_view" fallback={<Navigate to="/" />}><Uzytkownicy /></Guard>} />
                    <Route path="/towaryUslugi" element={<Guard permission="page_warehouse_view" fallback={<Navigate to="/" />}><TowaryUslugi /></Guard>} />
                    <Route path="/UstawieniaMagazynu" element={<Guard permission="page_warehouse_view" fallback={<Navigate to="/" />}><UstawieniaMagazynu /></Guard>} />
                    <Route path="/ustawienia" element={<Guard permission="page_settings_view" fallback={<Navigate to="/" />}><Ustawienia /></Guard>} />
                  </Routes>
                </div>
              </div>
              <Footer />
            </>
          ) : (
            <Navigate to="/logowanie" />
          )
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}